import React, { useCallback, useEffect, useMemo, useState } from "react";
import CommonLayout from "../../../layouts/commonLayout/CommonLayout";
import Printtest from "./printtest/Printtest";
import baseUrl from "../../../api/baseUrl";
import { useDispatch } from "react-redux";
import {
  setPresPrintaction,
  setPresPrintAmount,
  setPresPrintclinic,
  setPresPrintPatient,
  setPrintaction,
  setPrintAmount,
  setPrintclinic,
  setPrintPatient,
  setPrintTemplate2action,
  setPrintTemplate2Amount,
  setPrintTemplate2clinic,
  setPrintTemplate2Patient,
  setTokenPrintaction,
  setTokenPrintclinic,
  setTokenPrintToken,
} from "../../../redux/printstate/printActions";
import PrePrint from "./preprint/PrePrint";
import TokenPrint from "./tokenprint/TokenPrint";
import PrintIcon from "@mui/icons-material/Print";
import ReceiptIcon from "@mui/icons-material/Receipt";
import DescriptionIcon from "@mui/icons-material/Description";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { isPrintTemplate2Enabled } from "../../../utils/clinicFeatures";

function ManagePrint() {
  const dispatch = useDispatch();
  const printTemplate2Enabled = isPrintTemplate2Enabled();
  const [selectedOption, setSelectedOption] = useState<string>("bill");

  const dispatchPrintActions = useCallback(
    (e: any) => {
      e?.bills?.forEach((element: any) => {
        const { title, top, left, show, size, height, width } = element;
        if (top) dispatch(setPrintaction({ name: title, target: "top", value: top }));
        if (left) dispatch(setPrintaction({ name: title, target: "left", value: left }));
        if (height) dispatch(setPrintaction({ name: title, target: "height", value: height }));
        if (width) dispatch(setPrintaction({ name: title, target: "width", value: width }));
        if (show !== undefined)
          dispatch(setPrintaction({ name: title, target: "show", value: show }));
        if (size) dispatch(setPrintaction({ name: title, target: "size", value: size }));
      });
      dispatch(
        setPrintclinic({
          clinicName: e?.title,
          tpNo: e?.tpNo,
          address: e?.address,
          drName: "docto1 james",
          printImages: e?.printImages,
          headerImages: e?.headerImages,
          footerImages: e?.footerImages,
        })
      );
      dispatch(
        setPrintPatient({
          invoiceNo: "1245d4",
          regNo: "J/a1/2024",
          fullName: "user Name",
          mobileNo: "0771234567",
          gender: "female",
          dob: "2004-08-25T08:19:43.320+00:00",
        })
      );
      dispatch(
        setPrintAmount({
          total: 4,
          lastDue: 4,
          discount: 14,
          netotal: 4,
          card: 4,
          cash: 4,
          bankTransfer: 54,
        })
      );
    },
    [dispatch]
  );

  const dispatchPrintTemplate2Actions = useCallback(
    (e: any) => {
      e?.printTemplate_2?.forEach((element: any) => {
        const { title, top, left, show, size, height, width } = element;
        if (top) dispatch(setPrintTemplate2action({ name: title, target: "top", value: top }));
        if (left) dispatch(setPrintTemplate2action({ name: title, target: "left", value: left }));
        if (height) dispatch(setPrintTemplate2action({ name: title, target: "height", value: height }));
        if (width) dispatch(setPrintTemplate2action({ name: title, target: "width", value: width }));
        if (show !== undefined)
          dispatch(setPrintTemplate2action({ name: title, target: "show", value: show }));
        if (size) dispatch(setPrintTemplate2action({ name: title, target: "size", value: size }));
      });
      dispatch(
        setPrintTemplate2clinic({
          clinicName: e?.title,
          tpNo: e?.tpNo,
          address: e?.address,
          drName: "docto1 james",
          printImages: e?.printImages,
          headerImages: e?.headerImages,
          footerImages: e?.footerImages,
        })
      );
      dispatch(
        setPrintTemplate2Patient({
          invoiceNo: "1245d4",
          regNo: "J/a1/2024",
          fullName: "user Name",
          mobileNo: "0771234567",
          gender: "female",
          dob: "2004-08-25T08:19:43.320+00:00",
        })
      );
      dispatch(
        setPrintTemplate2Amount({
          total: 4,
          lastDue: 4,
          discount: 14,
          netotal: 4,
          card: 4,
          cash: 4,
          bankTransfer: 54,
        })
      );
    },
    [dispatch]
  );

  const dispatchTokenPrintActions = useCallback(
    (e: any) => {
      e?.tokenPrint?.forEach((element: any) => {
        const { title, top, left, show, size, height, width } = element;
        if (top) dispatch(setTokenPrintaction({ name: title, target: "top", value: top }));
        if (left) dispatch(setTokenPrintaction({ name: title, target: "left", value: left }));
        if (height) dispatch(setTokenPrintaction({ name: title, target: "height", value: height }));
        if (width) dispatch(setTokenPrintaction({ name: title, target: "width", value: width }));
        if (show !== undefined)
          dispatch(setTokenPrintaction({ name: title, target: "show", value: show }));
        if (size) dispatch(setTokenPrintaction({ name: title, target: "size", value: size }));
      });
      dispatch(
        setTokenPrintclinic({
          clinicName: e?.title,
          tpNo: e?.tpNo ?? "",
          phoneTwo: e?.tpNo2 ?? "",
          website: e?.website ?? "",
          email: e?.email ?? "",
          address: e?.address,
          drName: "Dr. Mayura Gamalath",
          printImages: e?.printImages,
          headerImages: e?.headerImages,
          footerImages: e?.footerImages,
        })
      );
      dispatch(
        setTokenPrintToken({
          tokenNo: "13",
          roomNumber: "1",
          patientName: "Ms. ISMA HIDAYATH",
          issuedAt: new Date().toISOString(),
        })
      );
    },
    [dispatch]
  );

  const dispatchPrePrintActions = useCallback(
    (e: any) => {
      e?.prescriptionBill?.forEach((element: any) => {
        const { title, top, left, show, size, width, height } = element;
        if (top)
          dispatch(setPresPrintaction({ name: title, target: "top", value: top }));
        if (left)
          dispatch(setPresPrintaction({ name: title, target: "left", value: left }));
        if (show !== undefined)
          dispatch(setPresPrintaction({ name: title, target: "show", value: show }));
        if (size)
          dispatch(setPresPrintaction({ name: title, target: "size", value: size }));
        if (width)
          dispatch(setPresPrintaction({ name: title, target: "width", value: width }));
        if (height)
          dispatch(setPresPrintaction({ name: title, target: "height", value: height }));
      });
      dispatch(
        setPresPrintclinic({
          clinicName: e?.title,
          tpNo: e?.tpNo,
          address: e?.address,
          drName: "docto1 james",
          printImages: e?.printImages,
          headerImages: e?.headerImages,
          footerImages: e?.footerImages,
        })
      );
      dispatch(
        setPresPrintPatient({
          invoiceNo: "1245d4",
          regNo: "J/a1/2024",
          fullName: "user Name",
          mobileNo: "0771234567",
          gender: "female",
          dob: "2004-08-25T08:19:43.320+00:00",
        })
      );
      dispatch(
        setPresPrintAmount({
          total: 4,
          lastDue: 4,
          discount: 14,
          netotal: 4,
          card: 4,
          cash: 4,
          bankTransfer: 54,
        })
      );
    },
    [dispatch]
  );

  useEffect(() => {
    baseUrl
      .get("/clinic/getBillData")
      .then((response) => {
        dispatchPrintActions(response.data.data);
        dispatchPrePrintActions(response.data.data);
        dispatchTokenPrintActions(response.data.data);
        if (printTemplate2Enabled) {
          dispatchPrintTemplate2Actions(response.data.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [
    dispatchPrintActions,
    dispatchPrePrintActions,
    dispatchTokenPrintActions,
    dispatchPrintTemplate2Actions,
    printTemplate2Enabled,
  ]);

  const options = useMemo(() => {
    const base = [
      { value: "bill", label: "Bill", icon: ReceiptIcon },
      { value: "pre", label: "Prescription", icon: DescriptionIcon },
      { value: "token", label: "Token", icon: ConfirmationNumberIcon },
    ];
    if (printTemplate2Enabled) {
      base.push({
        value: "printTemplate_2",
        label: "Print Template 2",
        icon: DescriptionIcon,
      });
    }
    return base;
  }, [printTemplate2Enabled]);

  useEffect(() => {
    if (!printTemplate2Enabled && selectedOption === "printTemplate_2") {
      setSelectedOption("bill");
    }
  }, [printTemplate2Enabled, selectedOption]);

  return (
    <CommonLayout>
      {/* Toggle Options */}
      <div className="bg-white rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100 p-4 mt-4">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-primary to-primaryLight rounded-xl flex items-center justify-center">
              <PrintIcon className="text-white" sx={{ fontSize: 20 }} />
            </div>
            <span className="font-semibold text-slate-700">Print Type:</span>
          </div>
          <div className="flex gap-2 p-1 bg-slate-100 rounded-xl">
            {options.map(({ value, label, icon: Icon }) => (
              <button
                key={value}
                onClick={() => setSelectedOption(value)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                  selectedOption === value
                    ? "bg-white text-indigo-600 shadow-sm"
                    : "text-slate-500 hover:text-slate-700"
                }`}
              >
                <Icon sx={{ fontSize: 18 }} />
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Print Preview */}
      <div className="bg-white rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100 p-6 mt-4">
        {selectedOption === "bill" ? (
          <Printtest viewsetting={true} />
        ) : selectedOption === "printTemplate_2" ? (
          <Printtest
            viewsetting={true}
            stateKey="printTemplate2"
            saveApi="/clinic/addPrintTemplate2Data"
            grabApi="/clinic/addPrintTemplate2GrabPosition"
            printAction={setPrintTemplate2action}
          />
        ) : selectedOption === "token" ? (
          <TokenPrint viewsetting={true} />
        ) : (
          <PrePrint viewsetting={true} />
        )}
      </div>
    </CommonLayout>
  );
}

export default ManagePrint;
